import { useCurrentUserSuspenseQuery } from "@/api/queries/useCurrentUserSuspenseQuery"
import TeachingQualifications from "@/pages/medewerkers/$userId/teaching_qualifications/TeachingQualifications"
import { createFileRoute } from "@tanstack/react-router"
import { PageHeader } from "toptaal-shared"

export const Route = createFileRoute("/profiel/lesbevoegdheid/")({
  component: RouteComponent,
})

function RouteComponent() {
  const { data } = useCurrentUserSuspenseQuery()

  return (
    <>
      <PageHeader className="mb-2">Lesbevoegdheid</PageHeader>
      <TeachingQualifications type="profile" userId={data.data.userId} />
    </>
  )
}
